import lightGhost from './../../images/light-ghost.png';
import darkGhost from './../../images/dark-ghost.png';
import lightCobweb from './../../images/light-cobweb.png';
import darkCobweb from './../../images/dark-cobweb.png';
import { useLanguage } from '../../context/LanguageContext';

export default function GameEndGhosts() {
  const { t } = useLanguage();

  return (
    <>
      {/* middle ghost */}
      <div className="flex pb-12 items-start">
        <img
          src={lightGhost}
          alt="Friendly ghost"
          className="w-40 h-40 sm:w-60 sm:h-60 z-0 block dark:hidden"
        />
        <img
          src={darkGhost}
          alt="Friendly ghost"
          className="w-40 h-40 sm:w-60 sm:h-60 z-0 hidden dark:block"
        />
        <p className="bg-white dark:bg-background-dark font-semibold text-darkgray dark:text-text-dark p-4 border rounded-tr-2xl rounded-tl-2xl rounded-br-2xl border-gray">
          {t('youGotMe')}
        </p>
      </div>

      <div className="hidden md:inline">
        {/* left cobweb */}
        <img
          src={lightCobweb}
          alt="Friendly cobweb"
          className="fixed top-[-6em] left-[-4em] w-60 h-60 z-0 block dark:hidden"
        />
        <img
          src={darkCobweb}
          alt="Friendly cobweb"
          className="fixed top-[-6em] left-[-4em] w-60 h-60 z-0 hidden dark:block"
        />
      </div>
    </>
  );
}
